var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.519 7.34779C33.9436 7.34779 34.3152 7.71936 34.3152 8.14401L34.2621 16.7963C34.2621 17.221 33.9436 17.5395 33.519 17.5395H31.7673V17.5926C31.3426 17.5926 30.9711 17.221 30.9711 16.7963L31.1303 12.8683L31.0242 12.7621L16.2143 27.5719C16.1082 27.6781 15.9489 27.7843 15.7897 27.7843C15.5774 27.7843 15.4181 27.6781 15.3119 27.5719L14.0911 26.3511C13.9849 26.2449 13.8787 26.0856 13.8787 25.8733C13.8787 25.7141 13.9849 25.5548 14.0911 25.4487L28.9009 10.6389L28.7947 10.5327L24.8667 10.6919C24.442 10.6919 24.1235 10.3204 24.1235 9.89571V8.14401C24.1235 7.71936 24.442 7.40087 24.8667 7.40087L33.519 7.34779ZM30.0687 22.6353C30.4933 22.6353 30.918 23.06 30.918 23.4846V31.9777C30.918 33.4109 29.7502 34.5257 28.3701 34.5257H9.68528C8.25207 34.5257 7.13735 33.4109 7.13735 31.9777V13.2929C7.13735 11.9128 8.25207 10.745 9.68528 10.745H18.1784C18.603 10.745 19.0277 11.1697 19.0277 11.5943V12.4436C19.0277 12.9214 18.603 13.2929 18.1784 13.2929H10.0038C9.79144 13.2929 9.68528 13.4522 9.68528 13.6114V31.6592C9.68528 31.8716 9.79144 31.9777 10.0038 31.9777H28.0516C28.2108 31.9777 28.3701 31.8716 28.3701 31.6592V23.4846C28.3701 23.06 28.7416 22.6353 29.2194 22.6353H30.0687Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1c8775e4131603cae14e4faa4a7d73a0.svg";
export { ForwardRef as ReactComponent };